import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {

  private _isClosing: boolean = false;
  private _isLoading: boolean = false;
  private _message: string = '';

  public get isClosing(): boolean {
    return this._isClosing;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get message(): string {
    return this._message;
  }

  /**
   * Start the loader with custom message.
   * @param message Loader message.
   */
  public startLoading(message: string = 'Cargando...'): void {
    setTimeout(() => {
      this._message = message;
      this._isLoading = true;
    }, 0);
  }

  /**
   * Stop the loader.
   */
  public stopLoading(): void {
    if(!this.isLoading)
      return;
    
    this._isClosing = true;
    setTimeout(() => {
      this._isLoading = false;
      this._isClosing = false;
    }, 200);
  }
}